import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Article, Page, PurchaseOrder, PurchaseOrderForm } from '../models';

@Injectable()
export class PurchaseOrderService {

    purchaseOrdersUrl = environment.dns + 'api/purchase-orders/';

    constructor(private http: HttpClient) { }

    getPaginate(page: number, size: number, search: String = ""): Observable<Page<PurchaseOrder>> {
        return this.http.get<Page<PurchaseOrder>>(this.purchaseOrdersUrl + 'paginate?page=' + page + '&size=' + size + '&search=' + search);
    }

    getOne(id: number): Observable<PurchaseOrder> {
        return this.http.get<PurchaseOrder>(this.purchaseOrdersUrl + id);
    }

    add(purchaseOrderForm: PurchaseOrderForm): Observable<Article> {
        return this.http.post<Article>(this.purchaseOrdersUrl, purchaseOrderForm);
    }

    update(purchaseOrderForm: PurchaseOrderForm): Observable<PurchaseOrder> {
        return this.http.put<PurchaseOrder>(this.purchaseOrdersUrl, purchaseOrderForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.purchaseOrdersUrl + id);
    }
}